import React from 'react';
import Modal from 'react-modal';
import theme from '@/data/theme';
import {
  StyledCancelButton,
  StyledIconWrapper,
  StyledLogoutButton,
} from '@/components/ui/Modals/LogoutModal/LogoutModal.styled.ts';
import { StyledLogoutIcon } from '@/components/ui/LogoutButton/LogoutButton.styled.ts';
import { useNavigate, useParams } from 'react-router-dom';
import AuthCookieHandler from '@/services/AuthCookieHandler';
import { ModalButtonWrapper } from '@/components/ui/Modals/TableActionModal/TableActionsModal.style.ts';

interface LogoutProps {
  isOpen: boolean;
  onClose: () => void;
}

const LogoutPopUpModal: React.FunctionComponent<LogoutProps> = ({ isOpen, onClose }) => {
  const handleModalClose = () => {
    onClose();
  };
  const authCookieHandler = new AuthCookieHandler();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleLogout = () => {
    authCookieHandler.removeAuth();
    window.location.reload();
    if (!authCookieHandler.getAuth()) {
      navigate(`/qr/${id}/admin-login`, {
        replace: true,
      });
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      shouldCloseOnOverlayClick={false}
      style={{
        content: {
          maxWidth: '320px',
          minWidth: '296px',
          height: 'fit-content',
          borderRadius: '10px',
          padding: '25px 25px',
          inset: '0',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          boxShadow: '0px 2px 6px 0px rgba(134, 92, 208, 0.50)',
          gap: '10px',
          fontFamily: 'Poppins',
        },
        overlay: {
          background: theme.colors.modalBackground,
        },
      }}
    >
      <StyledIconWrapper>
        <StyledLogoutIcon $variant="danger" $height={30} $width={30} />
      </StyledIconWrapper>
      <div>Are you sure you want to log out?</div>

      <ModalButtonWrapper>
        <StyledCancelButton onClick={onClose}>Cancel</StyledCancelButton>
        <StyledLogoutButton onClick={handleLogout}>Log out</StyledLogoutButton>
      </ModalButtonWrapper>
    </Modal>
  );
};

export default LogoutPopUpModal;
